import axios, { getEnv }from "../../../services/api";

export const RegrasContabilizacaoService = {
  getTemas: async (idTemaMacro) => {
    try {
      return await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/atendimentos/temas/${idTemaMacro}`
      );
    } catch (error) {
      throw error;
    }
  },
  getOptions: async (cadastro = true) => {
    try {
      return await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/opcoes?cadastro=${cadastro}`
      );
    } catch (error) {
      throw error;
    }
  },
  getProjetos: async () => {
    try {
      return await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/ativos`
      );
    } catch (error) {
      throw error;
    }
  },
  getProjeto: async (pratif) => {
    try {
      return await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/pratif/${pratif}`
      );
    } catch (error) {
      throw error;
    }
  },
  findAll: async (params, body = {}) => {
    try {
      const response = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/consultar`,
        body,
        { params }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  save: async (body) => {
    try {
      return await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras`,
        body
      );
    } catch (error) {
      throw error;
    }
  },

  update: async (body) => {
    try {
      return await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras`,
        body
      );
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      return await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/${id}/status/${status}`
      );
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      return await axios.delete(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/${id}`
      );
    } catch (error) {
      throw error;
    }
  },
  searchInput: async (body, params, source) => {
    const response = await axios.post(
      `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/consultar`,
      body,
      {
        params,
        cancelToken: source.token,
      }
    );
    source.cancel("Operação cancelada pelo usuário");
    return response.data;
  },
  getPedants: async (body = {}) => {
    const response = await axios.post(
      `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/regras/buscar-pendentes`,
      body
    );
    return response.data;
  },
};
